<div class="rounded-2xl border border-neutral-200 bg-white p-6 shadow-sm dark:border-neutral-800 dark:bg-neutral-800 mt-4">
  <div class="flex flex-col gap-6">
    <div class="flex items-start justify-between">
      <div class="space-y-1">
        <h3 class="text-lg font-bold text-neutral-900 dark:text-white">{{ name }}</h3>
        <p class="text-sm text-neutral-600 dark:text-neutral-400">{{ description }}</p>
      </div>
      <div
        class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
        [ngClass]="statusBadgeClass"
      >
        {{ statusLabel }}
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <span class="text-[11px] font-extrabold uppercase tracking-wider text-neutral-500">Possíveis Aprovadores</span>
      <div class="flex">
        @for (approver of workflow.users; track approver.userId) {
          <div
            class="flex h-10 w-10 items-center justify-center rounded-full border-2 border-white bg-neutral-100 text-neutral-600 shadow-sm dark:border-neutral-800 dark:bg-neutral-700 dark:text-neutral-400"
            [ngClass]="approverStatus(approver) === 'approved' ? 'bg-green-100 text-green-600 dark:bg-green-900/50 dark:text-green-400' : approverStatus(approver) === 'rejected' ? 'bg-red-100 text-red-600 dark:bg-red-900/50 dark:text-red-400' : ''"
            [title]="approver.userName"
            app-tool-tip
            [tooltip-text]="approver.userName"
          >
            <i
              [innerHTML]="(approverStatus(approver) === 'rejected' ? 'user-x' : (approverStatus(approver) === 'approved' ? 'user-check' : 'user')) | feather : { width: 18, height: 18 }"
              [ngClass]="approverStatus(approver) === 'approved' ? 'text-green-500' : approverStatus(approver) === 'rejected' ? 'text-red-500' : ''"
            ></i>
          </div>
        }
      </div>
    </div>

    @if (!workflow.isFinished && canPerformActions) {
      <div class="flex items-center gap-3 pt-2 flex-wrap">
        <!-- APROVAR -->
        <app-button
          color="primary"
          size="small"
          [disabled]="loading"
          (buttonClick)="openFeedbackModal(true)"
        >
          <div class="flex items-center gap-2">
            @if (!loading) {
              <span>Aprovar solicitação</span>
            } @else {
              <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24">
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                  fill="none"
                />
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                />
              </svg>
              <span>Processando…</span>
            }
          </div>
        </app-button>

        <!-- REPROVAR -->
        @if (!workflow.isOnlyApproval) {
          <app-button
            color="danger"
            size="small"
            [disabled]="loading"
            (buttonClick)="openFeedbackModal(false)"
          >
            <div class="flex items-center gap-2">
              @if (!loading) {
                <span>Reprovar</span>
              } @else {
                <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24">
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                    fill="none"
                  />
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  />
                </svg>
                <span>Processando…</span>
              }
            </div>
          </app-button>
        }

        <!-- Recompilar -->
        @if (workflow.isEveryoneMustApprove || !workflow.isOneUserApproval) {
          <app-button
            color="neutral"
            size="small"
            [disabled]="recompileLoading"
            (buttonClick)="onRecompile()"
          >
            <div class="flex items-center gap-2">
              @if (!recompileLoading) {
                <span>Recompilar workflow</span>
              } @else {
                <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24">
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                    fill="none"
                  />
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  />
                </svg>
                <span>Recompilando…</span>
              }
            </div>
          </app-button>
        }

        <!-- Cancelar -->
        <app-button
          color="danger"
          size="small"
          [disabled]="cancelLoading"
          (buttonClick)="onCancel()"
        >
          <div class="flex items-center gap-2">
            @if (!cancelLoading) {
              <span>Cancelar workflow</span>
            } @else {
              <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24">
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                  fill="none"
                />
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                />
              </svg>
              <span>Cancelando…</span>
            }
          </div>
        </app-button>
      </div>
    }
  </div>
</div>

<!-- Feedback Modal (required message for approve/deny) -->
<app-modal
  #feedbackModal
  [title]="pendingFeedbackApproved ? 'Aprovar solicitação' : 'Reprovar solicitação'"
  class="min-w-[400px]"
>
  <div class="space-y-4 max-w-md">
    <p class="text-sm text-neutral-600 dark:text-neutral-400">
      {{ pendingFeedbackApproved ? 'Informe o motivo da aprovação.' : 'Informe o motivo da reprovação.' }}
    </p>

    <div>
      <label for="feedbackMessage" class="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1">
        Mensagem <span class="text-red-500">*</span>
      </label>
      <textarea
        id="feedbackMessage"
        [(ngModel)]="feedbackMessage"
        rows="4"
        required
        class="w-full border border-neutral-300 dark:border-neutral-700 rounded-lg px-3 py-2 text-sm bg-white dark:bg-neutral-900 text-neutral-900 dark:text-neutral-100 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        placeholder="Digite sua mensagem de feedback..."
      ></textarea>
      @if (!feedbackMessage.trim()) {
        <p class="mt-1 text-xs text-amber-600 dark:text-amber-400">
          A mensagem é obrigatória.
        </p>
      }
    </div>

    <div class="flex justify-end gap-3">
      <app-button color="neutral" (buttonClick)="closeFeedbackModal()">
        Cancelar
      </app-button>
      <app-button
        [color]="pendingFeedbackApproved ? 'primary' : 'danger'"
        [disabled]="!feedbackMessage.trim() || loading"
        (buttonClick)="submitFeedback()"
      >
        @if (!loading) {
          {{ pendingFeedbackApproved ? 'Aprovar' : 'Reprovar' }}
        } @else {
          <span class="flex items-center gap-2">
            <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none" />
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
            </svg>
            Processando…
          </span>
        }
      </app-button>
    </div>
  </div>
</app-modal>
